export default __webpack_public_path__ + "static/media/colors-480w.d78c0111.webp";